import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Row, Col, Alert, Button, Label, CustomInput, FormText} from "reactstrap";
import {Input} from "mdbreact";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios/index";
import validator from "validator";
import CKEditor from "react-ckeditor-component";
import {API_URL, IMAGE_URL} from "../../config/Config";
import {LangValidation} from "./../../lang/fa/validation";
import PageLoader from "../loader/PageLoader";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import SaveLoader from "./../loader/SaveLoader";
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 3 });


class MerchantFormUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading1: false,
            activeItemPills: '1',
            fields: {
                title: '',
                alias: '',
                short_desc:'',
                description: '',
                cover: null,
                phone: '',
                website:'',
                address:'',
                instagram:'',
                telegram:'',
                whatsapp:'',
                postal_code:'',
                state:0,
                city_id:0,
                is_published:0,
                category1:0,
                category2:0,
                cover_image:'',
            },
            business_id:null,
            errors: {},
            hasAlert:false,
            categoryItem1:[],
            categoryItem2:[],
            show_cat2:true,
            statesItems:[],
            citesItem:[],
            show_cities:true,
            cites:[],
            imagePreviewUrl: '',
        };
    }

    async componentDidMount(){
        let categoryItem1 = await this.getCurrentLevelCat(0);
        this.setState({categoryItem1});
        await this.getStatesAndCities();
        //if have id
        let business_id = await this.props.id;
        let fields = await this.props.fields;


        if (business_id){
            this.setState({business_id, fields});
            const {city_id,category1} = fields;

            let state_id = this.state.cites.filter( city => city.id === city_id ).map(city => city.state_id);
            let sid = parseInt(state_id[0],10);
            fields['state'] = sid;
            let citesItem = await this.getStateCities(sid);
            let categoryItem2 = await this.getCurrentLevelCat(category1);
            this.setState({citesItem, categoryItem2,fields});
        }
    }



    async getStatesAndCities(){
        let response = await axios.get(`${API_URL}state-city`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            // alert('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.');
            toast.error("خطایی در هنگام دریافت اطلاعات از سرور رخ داد.",{
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
                rtl:true
            });
        }else{
            let states = response.data.states;
            let cites = response.data.cites;
            let statesItems = states.map(state => {
                    return {
                        value: state.id,
                        label: state.name
                    }
                });
           this.setState({
               statesItems,cites
           })
        }
    }

    getCurrentLevelCat(i){
         const catItems = this.props.categories.items
            .filter(cat =>parseInt(cat.parent_id,10) === i)
            .map(cat => {
                return {
                    value: cat.id,
                    label: cat.name
                }
            });
        return catItems;
    }
    getStateCities(i){
        const citesItem = this.state.cites
            .filter(city => parseInt(city.state_id,10) === i)
            .map(city => {
                return {
                    value: city.id,
                    label: city.name
                }
            });

        return citesItem;
    }

    handleValidation(callback) {
        let {fields} = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.title)) {
            formIsValid = false;
            errors["title"] = LangValidation.required;
        }else if (!validator.isLength(fields.title, {min: 3, max: undefined})) {
            formIsValid = false;
            errors["title"] = LangValidation.min;
        }
        if (fields.category1 <= 0) {
            formIsValid = false;
            errors["category1"] = LangValidation.required;
        }
        if (fields.category2 <= 0) {
            formIsValid = false;
            errors["category2"] = LangValidation.required;
        }
        if (fields.state <= 0) {
            formIsValid = false;
            errors["state"] = LangValidation.required;
        }
        if (fields.city_id <= 0) {
            formIsValid = false;
            errors["city_id"] = LangValidation.required;
        }


        /*if (validator.isEmpty(fields.cover)) {
            formIsValid = false;
            errors["cover"] = LangValidation.required;
        }*/

        this.setState({errors}, () => {
            return callback(formIsValid)
        });

    }

    handelCheck(event) {
        let fields = this.state.fields;
        let target = event.target;
        fields["is_published"] = 0;

        if (target.checked){
            fields["is_published"] = 1;
        }
        this.setState({fields});
    }

    handleFileChange(event) {
        event.preventDefault();
        let fields = this.state.fields;
        let reader = new FileReader();
        let file = event.target.files[0];
        fields["cover"] = file;
        reader.onloadend = () => {
            this.setState({
                fields,
                imagePreviewUrl: reader.result
            });
        };
        reader.readAsDataURL(file);

    }
    async handleCategoriesChange(selectedOption){
        let fields = this.state.fields;
        let parentId = parseInt(selectedOption.value,10);
        fields["category1"] = parentId;
        let categoryItem2 = await this.getCurrentLevelCat(parentId);
        this.setState({
            fields,
            show_cat2:true,
            categoryItem2
        });
    }
    handleSubCatChange(selectedOption){
        let fields = this.state.fields;
        fields["category2"] = selectedOption.value;
        this.setState({fields});
    }

    async handleChangeState(selectedOption){
        let fields = this.state.fields;
        let stateId = parseInt(selectedOption.value,10);
        fields["state"] = stateId;
        let citesItem = await this.getStateCities(stateId);
        this.setState({
            fields,
            show_cities:true,
            citesItem
        });
    }
    handleChangeCity(selectedOption){
        let fields = this.state.fields;
        fields["city_id"] = selectedOption.value;
        this.setState({fields});
    }

    handleChangEditor(event){
        let fields = this.state.fields;
        let newContent = event.editor.getData();
        fields["description"] = newContent;
        this.setState({fields})
    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;
        switch (target.name) {
            case 'title':
                if (validator.isEmpty(fields.title)) {
                    errors["title"] = LangValidation.required;
                }else if (!validator.isLength(fields.title, {min: 3, max: undefined})) {
                    errors["title"] = LangValidation.min;
                }
                break;
            default:
        }
        this.setState({
            fields,errors
        });

    }
    async handleRequest() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const { title, alias, short_desc, description, cover, phone, website, address, instagram, telegram, whatsapp, postal_code,city_id, is_published, category1, category2} = this.state.fields;
        formData.append('title',title);
        formData.append('alias',alias);
        formData.append('short_desc',short_desc);
        formData.append('description',description);
        formData.append('cover',cover);
        formData.append('phone',phone);
        formData.append('website',website);
        formData.append('address',address);
        formData.append('instagram',instagram);
        formData.append('telegram',telegram);
        formData.append('whatsapp',whatsapp);
        formData.append('postal_code',postal_code);
        formData.append('city_id',city_id);
        formData.append('is_published',is_published);
        formData.append('category1',category1);
        formData.append('category2',category2);

        this.setState({loading1: true});
        try{
        let response = await axios.post(`${API_URL}business-update/${this.state.business_id}?api_token=${this.props.user.apiToken}`,formData,config);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            toast.error("خطایی در هنگام ذخیره سازی اطلاعات رخ داد.",{
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
                rtl:true
            });
            }else{
                let business = response.data.data;
                this.setState({
                    business_id:business.id,
                });
                toast.success("اطلاعات با موفقیت ذخیره گردید.",{
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl:true
                });
                // this.props.history.push(`/edit-job`);
               /* this.props.history.push({
                    pathname: '/edit-job',
                    id: business.id
                });*/
            }

        }catch (e) {
            let apiError = await e.response;

            if (apiError === undefined) {
                console.log(e);
            } else {
                // let statusText = await apiError.statusText;
                // let status = await apiError.status;
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({apiErrorText});
            }
            this.setState({hasAlert:true});

        }
        console.log("done1");
        this.setState({loading1: false});
        //redirect to edit file

    };

    handleSubmit(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const {title, alias, short_desc, description, phone, website, address, instagram, telegram, whatsapp, postal_code,state,city_id, is_published, category1, category2,cover_image} = this.state.fields;
        const {errors, loading,imagePreviewUrl} = this.state;
        let imagePreview = null;
        if (imagePreviewUrl) {
            imagePreview = (<img src={imagePreviewUrl} alt='business cover' style={{width:160, height:'auto'}}/>);
        } else {
            imagePreview = (<img src={IMAGE_URL+cover_image} alt='business cover' style={{width:160, height:'auto'}}/> );
        }
        const CKToolbar = [
            {"name":"basicstyles","groups":["basicstyles"]},
            {"name":"links","groups":["links"]},
            {"name":"paragraph","groups":["list","blocks"]},
            {"name":"document","groups":["mode"]},
            {"name":"insert","groups":["insert"]},
            {"name":"styles","groups":["styles"]},
            // {"name":"about","groups":["about"]}
        ];

        if (this.state.business_id !== null) {
            // return <Redirect to={`/edit-job/${this.state.business_id}`} />;
        }

        return (
            <div className="pt-3 form-no-icon">
                <Row>
                    <Col md="12">
                        {this.state.hasAlert?
                            <Alert color="danger">
                                خطایی در هنگام ثبت اطلاعات رخ داد.
                            </Alert> :""}
                    </Col>
                </Row>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8"/>:
                    <form  onSubmit={(e)=>this.handleSubmit(e)} encType="multipart/form-data" >
                        <Row>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className={errors["title"]?"form-control is-invalid":"form-control"}
                                    label="نام برند یاشرکت*"
                                    name="title"
                                    value={title}
                                    onChange={this.handleChange.bind(this)}
                                />
                                {errors["title"]?<div className="invalid-feedback" >{errors["title"]}</div>:""}
                            </Col>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className={errors["alias"]?"form-control is-invalid":"form-control"}
                                    label="نام مستعار"
                                    name="alias"
                                    value={alias}
                                    onChange={this.handleChange.bind(this)}
                                />
                                {errors["alias"]?<div className="invalid-feedback" >{errors["alias"]}</div>:""}
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12">
                               <div className="md-select">
                                   <Label for="category1" >دسته*</Label>
                                   <Select
                                       placeholder="انتخاب دسته بندی"
                                       clearable={false}
                                       // rtl={true}
                                       className={errors["category1"]?"is-invalid":""}
                                       id="category1"
                                       name="category1"
                                       value={category1}
                                       onChange={this.handleCategoriesChange.bind(this)}
                                       options={this.state.categoryItem1}
                                   />
                                   {errors["category1"]?<div className="invalid-feedback" >{errors["category1"]}</div>:""}
                               </div>
                            </Col>
                            <Col md="6" sm="12">
                                {this.state.show_cat2 ?
                                    <div className="md-select">
                                        <Label for="category2" >زیر دسته*</Label>
                                        <Select
                                            placeholder="انتخاب زیر دسته"
                                            clearable={false}
                                            className={errors["category2"]?"is-invalid":""}
                                            id="category2"
                                            name="category2"
                                            value={category2}
                                            onChange={this.handleSubCatChange.bind(this)}
                                            options={this.state.categoryItem2}
                                        />
                                        {errors["category2"]?<div className="invalid-feedback" >{errors["category2"]}</div>:""}
                                    </div>:""
                                }

                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12">
                                <div className="md-select">
                                    <Label for="state" >استان*</Label>
                                    <Select
                                        placeholder="انتخاب استان"
                                        clearable={false}
                                        // rtl={true}
                                        className={errors["state"]?"is-invalid":""}
                                        id="state"
                                        name="state"
                                        value={state}
                                        onChange={this.handleChangeState.bind(this)}
                                        options={this.state.statesItems}
                                    />
                                    {errors["state"]?<div className="invalid-feedback" >{errors["state"]}</div>:""}
                                </div>
                            </Col>
                            <Col md="6" sm="12">
                                {this.state.show_cities ?
                                    <div className="md-select">
                                        <Label for="city_id" >شهر*</Label>
                                        <Select
                                            placeholder="انتخاب شهر"
                                            clearable={false}
                                            className={errors["city_id"]?"is-invalid":""}
                                            id="city_id"
                                            name="city_id"
                                            value={city_id}
                                            onChange={this.handleChangeCity.bind(this)}
                                            options={this.state.citesItem}
                                        />
                                        {errors["city_id"]?<div className="invalid-feedback" >{errors["city_id"]}</div>:""}
                                    </div>:""
                                }

                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" sm="12">
                                <Input type="text"
                                       label="آدرس"
                                       className="form-control"
                                       name="address"
                                       value={address}
                                       onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className="form-control"
                                    label="کد پستی"
                                    name="postal_code"
                                    value={postal_code}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className="form-control"
                                    label="تلفن"
                                    name="phone"
                                    value={phone}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className="form-control"
                                    label="وب سایت"
                                    name="website"
                                    value={website}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className="form-control"
                                    label="اینستاگرام"
                                    name="instagram"
                                    value={instagram}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className="form-control"
                                    label="کانال تلگرام"
                                    name="telegram"
                                    value={telegram}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                            <Col md="6" sm="12">
                                <Input
                                    type="text"
                                    className="form-control"
                                    label="واتس آپ"
                                    name="whatsapp"
                                    value={whatsapp}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" sm="12">
                                <Input type="text"
                                       label="شرح کوتاه- 70 کاراکتر"
                                       className="form-control"
                                       name="short_desc"
                                       value={short_desc}
                                       onChange={this.handleChange.bind(this)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" sm="12">
                                <div className="md-select">
                                    <Label for="category2" >شرح کامل</Label>
                                    <CKEditor
                                        className="form-control"
                                        name="description"
                                        // value={description}
                                        config={{
                                            language: 'fa',
                                            // allowedContent: true,
                                            toolbarGroups:CKToolbar,
                                        }}
                                        content={description}
                                        events={{"change": this.handleChangEditor.bind(this)}}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12" className="upload-file-wrapper">
                                <Label for="cover" className="mt-1">درج تصویر</Label>
                                <Input type="file"
                                       className={errors["cover"]?"form-control mt-0 is-invalid":"form-control mt-0"}
                                       name="cover"
                                       id="cover"
                                       onChange={this.handleFileChange.bind(this)}
                                />
                                {errors["cover"]?<div className="invalid-feedback" >{errors["cover"]}</div>:""}
                                <FormText color="muted">
                                    فرمت مجاز jpg، png و gif  و حجم کمتر از 1024 کیلوبایت می باشد.
                                </FormText>
                            </Col>
                            <Col md="6" sm="12" className="text-right">
                                <div className="imgPreview1 mt-4 p-1 border border-dark1" style={{display:'inline-block'}}>
                                    {imagePreview}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" sm="12">
                                    <CustomInput type="checkbox"
                                           label="انتشار این کسب و کار"
                                           // className="form-control"
                                           name="is_published"
                                           id="is_published"
                                           // value={is_published}
                                           checked={is_published}
                                           onChange={this.handelCheck.bind(this)}
                                    />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12"> </Col>
                            <Col md="6" sm="12">
                                <div className="text-left mt-5">
                                    <Button color="default" block onClick={this.handleSubmit.bind(this)} className="mb-4 mt-4">
                                        ثبت<i className="fa fa-paper-plane-o white-text ml-1"></i>
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </form>}
                {this.state.loading1 ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        categories: state.categories,
        user: state.user,
    }
}

export default connect(mapStateToProps,null)(MerchantFormUpdate);



// WEBPACK FOOTER //
// ./src/components/merchants/MerchantFormUpdate.js